import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const walletService = {
  getMine, getMyTransactions, getAll, get, getTransactions, withdraw, adjust,
}

const API_URL = API.BASE_URL + '/v1'

// Your own wallet needs no permission — it is your own collection.
export function getMine() {
  return apiHelper(API_URL).get('/wallet/me')
}
export function getMyTransactions(params = {}) {
  return apiHelper(API_URL).get('/wallet/me/transactions', { params })
}

// Everybody else's needs Read Wallet / Update Wallet.
export function getAll(params = {}) {
  return apiHelper(API_URL).get('/wallets', { params })
}
export function get(userUuid) {
  return apiHelper(API_URL).get(`/wallets/${userUuid}`)
}
export function getTransactions(userUuid, params = {}) {
  return apiHelper(API_URL).get(`/wallets/${userUuid}/transactions`, { params })
}
export function withdraw(userUuid, data) {
  return apiHelper(API_URL).post(`/wallets/${userUuid}/withdraw`, data)
}
export function adjust(userUuid, data) {
  return apiHelper(API_URL).post(`/wallets/${userUuid}/adjust`, data)
}
